var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlinedPersonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3101 14.25H10.8101V12.75C10.8101 12.15 10.5701 11.58 10.1501 11.16C9.73006 10.74 9.16006 10.5 8.56006 10.5H5.56006C4.96006 10.5 4.39006 10.74 3.97006 11.16C3.55006 11.58 3.31006 12.15 3.31006 12.75V14.25H1.81006V12.75C1.81006 11.76 2.21006 10.8 2.91006 10.1C3.61006 9.4 4.57006 9 5.56006 9H8.56006C9.55006 9 10.5101 9.4 11.2101 10.1C11.9101 10.8 12.3101 11.76 12.3101 12.75V14.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06 1.5C7.51 1.5 7.94 1.63 8.31 1.88C8.68 2.13 8.97 2.48 9.14 2.89C9.31 3.3 9.35 3.75 9.27 4.19C9.18 4.63 8.97 5.03 8.65 5.34C8.34 5.65 7.93 5.87 7.5 5.96C7.06 6.05 6.61 6 6.2 5.83C5.79 5.66 5.44 5.37 5.19 5C4.94 4.63 4.81 4.19 4.81 3.75C4.81 3.15 5.05 2.58 5.47 2.16C5.89 1.74 6.46 1.5 7.06 1.5ZM7.06 0C6.32 0 5.59 0.22 4.98 0.63C4.36 1.04 3.88 1.63 3.6 2.31C3.32 3 3.24 3.75 3.39 4.48C3.53 5.21 3.89 5.88 4.42 6.4C4.94 6.92 5.61 7.28 6.34 7.43C7.07 7.57 7.82 7.5 8.51 7.22C9.2 6.94 9.78 6.46 10.19 5.84C10.6 5.22 10.82 4.5 10.82 3.76C10.82 2.77 10.42 1.81 9.72 1.11C9.02 0.41 8.06 0.00999999 7.07 0.00999999L7.06 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.5H0.5V18H21.5V16.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3.76001H18.5V0.76001H17V3.76001H14V5.26001H17V8.26001H18.5V5.26001H21.5V3.76001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlinedPersonPlus);
export default __webpack_public_path__ + "static/media/ic-outlined-person-plus.5d9157be346df2528747cee7cf589618.svg";
export { ForwardRef as ReactComponent };